import _extends from 'babel-runtime/helpers/extends';
import Icon from './index';
import * as React from 'react';
var customCache = new Set();
export default function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
    _options$extraCommonP = options.extraCommonProps,
    extraCommonProps = _options$extraCommonP === undefined ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', 'https:' + scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }
  var Iconfont = function Iconfont(props) {
    var type = props.type;
    // component > children > type

    var content = null;
    if (props.type) {
      content = React.createElement('use', {
        xlinkHref: '#' + type
      });
    }
    if (props.children) {
      content = props.children;
    }
    return React.createElement(Icon, _extends({}, props, extraCommonProps), content);
  };
  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}